import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import ThongTinCongTy from './ThongTinCongTy';


const useStyles = makeStyles((theme) => ({
    boxTitle: {
        textAlign: 'center',
    },
    title: {
        marginBottom: theme.spacing(3),
        fontWeight: 'bold',
        fontSize: '1.5rem',
        color: '#000',
    },
    boldText: {
        fontWeight: 'bold',
    },
    link: {
        textDecoration: 'none !important',
        color: 'inherit !important', // Kế thừa màu từ button
        '&:hover': {
            textDecoration: 'none !important',
            color: 'inherit !important',
        },
        '&:focus': {
            outline: 'none !important',
        },
    },
    // THÊM CLASS MỚI CHO HÌNH ẢNH RESPONSIVE Ở ĐÂY
    responsiveImage: {
        maxWidth: '100%', // Đảm bảo hình ảnh không vượt quá chiều rộng của phần tử cha
        height: 'auto',   // Tự động điều chỉnh chiều cao để duy trì tỷ lệ khung hình
        display: 'block', // Đảm bảo hình ảnh là block-level để áp dụng margin tự động
        margin: theme.spacing(2, 'auto'), // Căn giữa hình ảnh và thêm khoảng cách trên/dưới
    },
}));

const GioiThieuDichVu = () => {
    const classes = useStyles();


    return (
        <Box className={classes.root}>
            <Box className={classes.boxTitle}>
                <Typography variant="h5" className={classes.title}>
                    Giới thiệu về hoạt động Dịch vụ tại Đại lý Thái Nguyên Ford
                </Typography>
            </Box>
            <Box>
                <Typography component="span" className={classes.boldText}>Với tổng diện tích xây dựng trên 10.000 m2, Ford Thái Nguyên được xây dựng gồm hai khu chính: khu văn phòng rộng hơn 2600 m2....</Typography>
                <br />
                <Typography variant="body1" >
                    Với tổng diện tích xây dựng trên 10.000 m2, Ford Thái Nguyên được xây dựng gồm hai khu chính: khu văn phòng rộng hơn 2600 m2, khu xưởng dịch vụ và bảo dưỡng sửa chữa rộng hơn 5000 m2, gồm 12 khoang bảo dưỡng và sửa chữa chung; 22 khoang sửa chữa thân xe và sơn, cùng các khoang chức năng riêng biệt…
                </Typography>
                <br />
                {/* ÁP DỤNG CLASS RESPONSIVEIMAGE VÀO THẺ IMG */}
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/dic-vu-tnf-8.jpg' className={classes.responsiveImage} alt="Thái Nguyên Ford" />
                <br />
                <Typography variant="body1" >
                    Khu vực mặt bằng tầng 2 dành cho xưởng đồng sơn và thân, vỏ xe với các trang thiết bị tiêu chuẩn. Đặc biệt, Thái Nguyên Ford là đại lý duy nhất trong hệ thống của Ford Việt Nam được trang bị bộ kéo nắn di động gồm thước đo điện tử 3D nhập khẩu từ Thụy Điển. Được xây dựng trở thành điểm bán hàng và cung cấp dịch vụ  theo tiêu chuẩn của Ford Toàn Cầu”, Thái Nguyên Ford dự kiến có khả năng phục vụ trên 100 lượt xe mỗi ngày.
                </Typography>
                <br />
                {/* ÁP DỤNG CLASS RESPONSIVEIMAGE VÀO THẺ IMG */}
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/dic-vu-tnf-6.jpg' className={classes.responsiveImage} alt="Khai trương đại lý" />
                <br />
                <Typography variant="body1" >
                    Ngay từ đầu xây dựng, hoạt động dịch vụ của Thái Nguyên Ford đã có hệ thống các quy trình tối ưu và tiên tiến nhất để đảm bảo chất lượng dịch vụ luôn được thực hiện theo tiêu chuẩn toàn cầu. TNF luôn đặt nhiệm vụ là hoàn thiện toàn bộ hệ thống quy trình  nghiệp vụ, nâng cao chất lượng phục vụ, đa dạng hóa các sản phẩm dịch vụ để thỏa mãn mọi nhu cầu của quý khách hàng với chính sách linh hoạt và nhanh chóng nhất.
                    Trải qua quá trình xây dựng và phát triển, Ford Thái Nguyên từ một thành viên trẻ trong gia đình FORD VIỆT NAM, bằng sự nỗ lực học hỏi, sáng tạo của tập thể cán bộ, nhân viên toàn công ty đã đưa FORD THÁI NGUYÊN phát triển lớn mạnh và gặt hái được những thành công nhất định.  Với tâm thế không ngừng nỗ lực, chắc chắn Thái Nguyên Ford sẽ góp phần gia tăng đáng kể về chất lượng Dịch vụ thông qua các hoạt động mang đến những giá trị được khách hàng đánh giá cao.
                </Typography>
                <br />

                <br />
                {/* ÁP DỤNG CLASS RESPONSIVEIMAGE VÀO THẺ IMG */}
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/image-20180613102534-3.jpeg' className={classes.responsiveImage} alt="Sửa chữa Ford" />
                <br />
                <Typography variant="body1" >
                    Chất lượng Dịch vụ của Ford đảm bảo niềm đam mê và hứng khởi trên mỗi chặng đường của bạn.
                    THÁI NGUYÊN FORD luôn cam kết đem tới quý Khách hàng những người sở hữu xe Ford niềm vui bất tận không chỉ sau khi bạn rời cánh cửa phòng trưng bầy mà còn hơn thế nữa.Chúng tôi tự hào là người hiểu rõ nhất về chiếc xe Ford của bạn. Chúng tôi cung cấp đầy đủ dịch vụ và phụ tùng chi tiết cần thiết nhằm mang đến cho bạn sự an tâm tuyệt đối cho dù bạn ở bất kỳ đâu và bất kỳ thời điểm nào.
                </Typography>
                <br />
                <Typography variant="body1" >
                    THÁI NGUYÊN FORD có sẵn các giải pháp hoàn hảo, từ thời gian bảo hành cho đến các yêu cầu riêng biệt đáp ứng phong cách của riêng bạn. Dịch vụ của THÁI NGUYÊN FORD không những đảm bảo chiếc xe của bạn luôn hoàn hảo, giúp bạn tiết kiệm chi phí sử dụng, hài lòng với tính năng tối ưu mà còn gia tăng giá trị bán lại của xe.
                </Typography>
                <br />
                {/* ÁP DỤNG CLASS RESPONSIVEIMAGE VÀO THẺ IMG */}
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/dic-vu-tnf-001.jpg' className={classes.responsiveImage} alt="Trải nghiệm Ford" />
                <br />
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/dic-vu-tnf-7_1.jpg' className={classes.responsiveImage} alt="Trải nghiệm Ford" />
                <br />
                <Typography component="span" className={classes.boldText}>
                    Ford Thái Nguyên : Cơ sở vật chất hiện đại - Quy trình chuyên nghiệp
                </Typography>
                <br />
                <br />
                <Typography variant="body1" >
                    Với tổng diện tích trên 10.000 m2 gồm kho bãi, nhà xưởng và khu vực kinh doanh, đại lý Ford Thái Nguyên có đầy đủ không gian và máy móc hiện đại để đáp ứng các nhu cầu giao xe, bảo dưỡng và sửa chữa một cách nhanh chóng, chuyên nghiệp. Dịch vụ của Thái Nguyên Ford được cung cấp bởi các trang thiết bị chuẩn đoán hiện đại bậc nhất thế giới sẽ nhanh chóng phát hiện và đưa ra những giải pháp tốt và hoàn hảo nhất cho chiếc xe của bạn.<br />Hệ thống phòng chờ khách hàng được thiết kế với không gian thoáng mát, thân thiện với các tiện nghi giải trí cáo cấp sẽ giúp khách hàng của Thái Nguyên Ford có khoảng thời gian thoải mái, vui vẻ trong khi chờ nhận xe, bảo dưỡng hoặc sửa chữa.
                </Typography>
                <br />
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/dic-vu-tnf-3.jpg' className={classes.responsiveImage} alt="Trải nghiệm Ford" />
                <br />
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/dic-vu-tnf-3.jpg' className={classes.responsiveImage} alt="Trải nghiệm Ford" />
                <br />
                <Typography component="span" className={classes.boldText}>
                    Thái Nguyên Ford: Đội ngũ nhân viên - tay nghề được kiểm chứng
                </Typography>
                <br />
                <br />
                <Typography variant="body1" >
                    Thái Nguyên Ford tự hào có được đội ngũ nhân viên, kỹ thuật viên lành nghề, được đào tạo, đạt chuẩn theo hệ thống đào tạo chuyên nghiệp của FORD. Mỗi kỹ thuật viên của Ford luôn cam kết cung cấp chất lượng dịch vụ hoàn hảo. Do đó, khách hàng sẽ hoàn toàn yên tâm khi chăm sóc chiếc xe của mình tại các Đại lý của chúng tôi. Ngoài ra, Thái Nguyên Ford cũng thường xuyên tổ chức các lớp đào tạo, hướng dẫn khách hàng kỹ năng lái xe an toàn, chăm sóc và cách thức sử dụng xe tốt nhất.
                </Typography>
                <br />
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/dic-vu-tnf-2.jpg' className={classes.responsiveImage} alt="Trải nghiệm Ford" />
                <br />
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/dic-vu-tnf-1.jpg' className={classes.responsiveImage} alt="Trải nghiệm Ford" />
                <br />
                <br />
                <Typography component="span" className={classes.boldText}>
                    Ford Protect
                </Typography>
                <br />
                <br />
                <Typography variant="body1" >
                    Ford Protect không chỉ đem đến những gói dịch vụ đa dạng, lý thú đối với mọi loại sản phẩm của Ford nhằm tăng sự hài lòng của khách hàng mà còn củng cố niềm tin, sự an tâm của mỗi chủ sở hữu xe Ford.
                </Typography>
                <br />
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/image-20180613102534-10.jpeg' className={classes.responsiveImage} alt="Trải nghiệm Ford" />
                <br />
                <Typography variant="body1" >
                    Thái Nguyên Ford - Quy trình hoạt động Dịch vụ tiêu chuẩn:
                    Các quy trình không hoàn thiện thường làm mất thời gian của khách hàng và khó tránh khỏi các sai sót không đáng có về thủ tục. Thái Nguyên Ford luôn không ngừng nỗ lực để củng cố, hoàn thiện quy trình, hoạt động dịch vụ tổng thể, đảm bảo khách hàng có những trải nghiệm chuyên nghiệp nhất khi mua hàng tại công ty.
                </Typography>
                <br />
                <Typography variant="body1" >
                    Cơ sở vật chất, trang thiết bị hiện đại theo tiêu chuẩn FORD: Với việc xây dựng cơ sở vật chất hiện đại, trang bị các thiết bị tiện nghi, tiên tiến được chứng nhận thường niên theo tiêu chuẩn của tập đoàn FORD, Thái Nguyên Ford đảm bảo tối ưu hóa thời gian và chất lượng làm dịch vụ cho khách hàng. Xe của khách hàng sẽ được bảo dưỡng, sửa chữa với chất lượng cao nhất và trong thời gian ngắn nhất.
                </Typography>
                <br />
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/image-20180613102534-11.jpeg' className={classes.responsiveImage} alt="Trải nghiệm Ford" />
                <br />
                <Typography component="span" className={classes.boldText}>
                    Quy trình tiếp nhận Dịch vụ sửa chữa chung của chúng tôi
                </Typography>
                <br />
                <img src='http://fordthainguyen.com.vn/uploads/dich-vu/image-20180613102534-12.jpeg' className={classes.responsiveImage} alt="Trải nghiệm Ford" />

                <Typography component="span" className={classes.boldText}>
                    Quy trình Dịch vụ sửa chữa đồng sơn của chúng tôi
                </Typography>
                <br />
                <br />
                <Typography component="span" className={classes.boldText}>
                    Phiếu Kiểm Tra Tình Trạng Xe
                </Typography>
                <br />
                <br />
                <Typography variant="body1" >
                    Tại các Đại lý ủy quyền của Ford, các kỹ thuật viên luôn ghi lại việc kiểm tra, đo đạc phụ tùng lên phiếu kiểm tra xe và đánh dấu theo màu các trạng thái.
                    Thẻ kiểm tra như 1 bản tóm tắt thông tin nhanh về tình trạng xe.
                    Việc này giúp khách hàng biết rõ tình trạng các phụ tùng trên xe, kiểm soát và đưa ra các quyết định phù hợp.
                </Typography>
                <br />
                <Typography component="span" className={classes.boldText}>
                    Lời kết
                </Typography>
                <br />
                <br />
                <Typography variant="body1" >
                    Thái Nguyên Ford  là trung tâm phân phối, sửa chữa, bảo dưỡng và bảo hành xe toàn tỉnh Thái Nguyên và các tỉnh trung du miền núi phía Bắc như Lào Cai, Yên Bái, Hà Giang, Tuyên Quang, Bắc Kạn. Mặc dù mới chỉ đi vào hoạt động vào cuối năm 2017 nhưng Thái Nguyên Ford đã và đang khẳng định được vị thế của mình trong hệ thống các đơn vị phân phối, kinh doanh ô tô trên địa bàn; không ngừng gia tăng giá trị doanh nghiệp, lấy hiệu quả kinh tế làm động lực phát triển, góp phần thực hiện các mục tiêu lớn trên thị trường xe ô tô.
                </Typography>
                <br />
                <br />
                <ThongTinCongTy />
            </Box>
        </Box>
    );
};

export default GioiThieuDichVu;